import styled from '@emotion/styled';
import { mediaQueries, remCalc, touchScroll, font, focuses } from '../../css';
import { StyledSvg } from '../../UI/Icon/IconSvg.css';

const arrowStyles = [
    () => ({
        zIndex: 2,
        cursor: 'pointer',
        [mediaQueries.medium]: {
            padding: remCalc(0, 10),
        },
    }),
    ({ touchDevice, visible, theme }) =>
        touchDevice
            ? {
                  display: 'none',
              }
            : {
                  ...(!visible
                      ? {
                            visibility: 'hidden',
                        }
                      : {}),

                  ...focuses.rgaa(':hover,:focus', {
                      color: theme.guide.activeSlideColor,
                      borderColor: theme.guide.activeSlideColor,
                  }),

                  [StyledSvg]: {
                      fill: theme.guide.activeSlideColor,
                  },
              },
];

const StyledArrowPrev = styled('button')(...arrowStyles);
const StyledArrowNext = styled('button')(...arrowStyles);

const StyledSliderSlides = styled('div')(() => ({
    display: 'flex',
    transitionDuration: '500ms',
    transitionTimingFunction: 'cubic-bezier(.31, .75, .43, .95)',
    transitionProperty: 'transform',
}));

const StyledSliderWrapper = styled('div')(() => ({
    overflow: 'hidden',
    flex: '1',
}));

const StyledSliderSlideRules = {
    margin: 0,
    fontSize: font.size.xs,
    lineHeight: 'normal',
    outline: 'none',
    // Note 1:  IE does not support calc syntax...
    // Note 2:  we don't set the width on flex as it has some
    //          issue with offsetWidth calculation in JS
    flex: '0 0 auto',
    width: '33.333%',

    [mediaQueries.medium]: {
        width: '20%',
    },
    [mediaQueries.large]: {
        width: '14.285%',
    },
};

const StyledSliderSlide = styled('div')(StyledSliderSlideRules);

const StyledSliderSlideCurrent = styled('h2')(StyledSliderSlideRules, ({ theme }) => ({
    background: theme.global.textColor,
    borderColor: theme.guide.activeSlideColor,
}));

const StyledSlider = styled('div')(
    () => ({
        display: 'flex',
        position: 'relative',
        [mediaQueries.medium]: {
            marginBottom: remCalc(15),
        },
    }),
    ({ theme, touchDevice }) => ({
        color: theme.global.textColor,
        backgroundColor: theme.global.navBgColor,

        ...(touchDevice
            ? touchScroll(StyledSliderSlides, {
                  prev: StyledArrowPrev,
                  next: StyledArrowNext,
              })
            : {}),
    }),
);

export {
    StyledSlider,
    StyledSliderWrapper,
    StyledSliderSlides,
    StyledSliderSlide,
    StyledSliderSlideCurrent,
    StyledArrowNext,
    StyledArrowPrev,
};
